<template>
  <transition name="scroll-top-button">
    <button
      v-show="scrolled"
      v-tealium:click="tealium"
      :data-wptv="dataWptv"
      :class="['scroll-to-top', scrolled ? 'visible' : '']"
      :aria-label="title"
      :title="title"
      @click="scrollToTop()"
      @keyup.enter="scrollToTop(true)">
      <wptv-icon
        :invert="true"
        :specific-alt="''"
        class="icon-arrow"
        name="arrow-left"
        height="25px"
        width="25px" />
    </button>
  </transition>
</template>

<script>
import _debounce from 'lodash/debounce'
import WptvIcon from '../icon/Icon'

export default {
  name: 'WptvScrollTopButton',
  components: { WptvIcon },
  props: {
    title: {
      type: String,
      required: true
    },
    limit: {
      type: Number,
      default: 200
    },
    target: {
      type: Number,
      default: 0
    },
    tealium: {
      type: Object,
      required: true
    },
    dataWptv: {
      type: String,
      required: true
    },
    tabTargetId: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      scrolled: false
    }
  },
  mounted () {
    document.addEventListener('scroll', _debounce(this.onScroll))
    this.onScroll()
  },
  methods: {
    scrollToTop (resetFocus = false) {
      try {
        window.scrollTo({ top: this.target, behavior: 'smooth' })
      } catch (error) {
        window.scrollTo(0, this.target)
      }
      // used to put the focus on an element in the top of the page
      // for accessibility
      const tabTargetElement = resetFocus && this.tabTargetId && document.getElementById(this.tabTargetId)
      if (tabTargetElement) {
        return tabTargetElement.focus()
      }
    },
    onScroll () {
      this.scrolled = window.scrollY >= this.limit
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../scss/abstracts/variables';

  .scroll-to-top {
    background: rgba(50, 50, 50, 0.6);
    position: fixed;
    bottom: 60px;
    right: 10px;
    border: 0;
    z-index: 999;
    padding-bottom: 3px;
    height: 50px;
    width: 50px;
    border-radius: 50%;
    opacity: 0;
    transition: opacity 0.5s;

    &.visible {
      opacity: 1;
    }

    &:hover {
      background: map-get($wptv-palette, 'primary');
      cursor: pointer;
    }

    &:focus {
      outline: none;
      // use of border instead of outline to have a round ring instead of a square
      border: 0.1875rem $primary solid ;
    }

    .icon-arrow {
      transform: rotate(90deg);
    }
  }
</style>
